import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthGuard } from './guards/auth.guard';
import { DeactivateGuard } from './guards/deactivate.guard';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { CurrencyService } from './services/currency.service';
import { LocaleService } from './services/locale.service';
import { UserService } from './services/user.service';
import { VisualisationService } from './services/visualisation.service';
import { RoleGuard } from './guards/role.guard';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    exports: [],
    providers: [
        CookieService,
        CurrencyService,
        LocaleService,
        UserService,
        AuthGuard,
        RoleGuard,
        DeactivateGuard,
        VisualisationService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: Window,
            useValue: window,
        },
    ],
})
export class CoreModule {}
